module.exports = __webpack_public_path__ + "img/02-thumb.5f3744ef.png";